import { ArchiveRounded, ChevronRightRounded, CollectionsRounded, RefreshRounded } from "@mui/icons-material";
import { Box, Breadcrumbs, Button, IconButton, Tooltip, alpha } from "@mui/material";
import { grey } from "@mui/material/colors";
import { itemTypes, rootArchivePath } from "../data";

const PRIMARY = "#212121";

const ArchiveToolbar = ({ currentPath, currentFolderName, breadcrumbParts, onNavigate, onDownload, onRefresh, onOpenJobs }) => {
	return (
		<Box
			px={2.5}
			py={1.5}
			display="flex"
			alignItems="flex-start"
			gap={2}
			flexWrap="wrap"
			borderBottom={`1px solid ${alpha(grey[900], 0.08)}`}
			sx={{ bgcolor: "background.paper" }}>
			<Box minWidth={0} flex={1} overflow="hidden" display="flex" alignItems="center" minHeight={36}>
				<Breadcrumbs
					separator={<ChevronRightRounded sx={{ fontSize: 14, color: grey[400] }} />}
					aria-label="archive-breadcrumbs"
					sx={{ "& .MuiBreadcrumbs-ol": { flexWrap: "wrap" } }}>
					<Box
						onClick={() => onNavigate("")}
						sx={{
							display: "flex",
							alignItems: "center",
							gap: 0.5,
							cursor: "pointer",
							color: currentPath ? grey[500] : PRIMARY,
							fontWeight: currentPath ? 400 : 600,
							fontSize: "0.82rem",
							"&:hover": { color: PRIMARY },
							transition: "color 0.15s",
						}}>
						<CollectionsRounded sx={{ fontSize: 14 }} />
						Shoot Archive
					</Box>
					{breadcrumbParts.map((part, index) => {
						const path = `${rootArchivePath}/${breadcrumbParts.slice(0, index + 1).join("/")}`;
						const isLast = index === breadcrumbParts.length - 1;
						return (
							<Box
								key={path}
								onClick={() => onNavigate(path)}
								sx={{
									cursor: "pointer",
									color: isLast ? PRIMARY : grey[500],
									fontWeight: isLast ? 600 : 400,
									fontSize: "0.82rem",
									"&:hover": { color: PRIMARY },
									transition: "color 0.15s",
								}}>
								{part}
							</Box>
						);
					})}
				</Breadcrumbs>
			</Box>

			<Box display="flex" alignItems="center" gap={1} flexShrink={0}>
				{currentPath && (
					<Button
						size="small"
						variant="outlined"
						startIcon={<ArchiveRounded sx={{ fontSize: 15 }} />}
						onClick={() => onDownload({ type: itemTypes.folder, path: currentPath, name: currentFolderName })}
						sx={{
							borderRadius: "8px",
							textTransform: "none",
							fontSize: "0.78rem",
							borderColor: alpha(grey[900], 0.2),
							color: "text.secondary",
							"&:hover": { borderColor: grey[400], bgcolor: alpha(grey[900], 0.04) },
						}}>
						Zip Folder
					</Button>
				)}
				<Tooltip title="Refresh">
					<IconButton
						size="small"
						onClick={onRefresh}
						sx={{
							borderRadius: "8px",
							border: `1px solid ${alpha(grey[900], 0.15)}`,
							"&:hover": { bgcolor: alpha(grey[900], 0.05) },
						}}>
						<RefreshRounded sx={{ fontSize: 18 }} />
					</IconButton>
				</Tooltip>
				<Button
					size="small"
					variant="contained"
					startIcon={<ArchiveRounded sx={{ fontSize: 15 }} />}
					onClick={onOpenJobs}
					sx={{
						borderRadius: "8px",
						textTransform: "none",
						fontSize: "0.78rem",
						boxShadow: "none",
						"&:hover": { boxShadow: "none" },
					}}>
					Active Jobs
				</Button>
			</Box>
		</Box>
	);
};

export default ArchiveToolbar;
